export enum ACCESS_KEY_TYPE {
    CARD = 'card',
    CHIP = 'chip',
    TAG = 'tag',
    PASSWORD = 'password',
}
export type AccessKey = {
    id: string;
    type: ACCESS_KEY_TYPE;
    value: string;
    modified_at?: string;
    created_at?: string;
    valid_from?: string;
    valid_to?: string;
    pass_back_allowed?: boolean;
};
